import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { DisputeProgressComponent } from './DisputeProgressComponent';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { FieldLabel } from 'web-ui-components/lib/typography/labels';
import {
  PAGE_CLAIM_AMOUNT,
  CLAIM_TYPE,
  PAGE_WE_HAVE_GOT_IT,
  PAGE_WHAT_DIDNT_YOU_RECEIVE,
  PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER,
  GOODS,
  TRAVEL,
  WEB_ERROR_TASK,
} from '../../../constants/FraudAndDisputeConstants';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import { PaymentDetailComponent } from './PaymentDetailComponent';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import general from '../../../config/General';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import LoaderComponent from '../../common/LoaderComponent';
import { getDisputeApiPayload } from '../../../parsers/FraudAndDisputeParser';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';
import { requestCustomerDetails } from '../../../utils/CustomerDetailsApiUtils';

export class ReviewYourDispute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isContinueClicked: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    FraudAndDisputeStore.addChangeListener(this.onStoreChange);
  }
  onStoreChange = () => {
    const { setPage } = this.props;
    const { isContinueClicked } = this.state;
    if (FraudAndDisputeStore.getIsDisputeCaseCreated()) {
      this.setState({ isLoading: false });
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_case_success,
        config.analytics.analytics_action_button_click
      );
      return setPage(PAGE_WE_HAVE_GOT_IT);
    }
    if (!FraudAndDisputeStore.getIsDisputeCaseCreated() && isContinueClicked) {
      this.setState({ isLoading: false });
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_case_failure,
        config.analytics.analytics_action_button_click
      );
      return InternetBankingActions.navigateToWebTask(WEB_ERROR_TASK);
    }
  };
  componentWillUnmount() {
    FraudAndDisputeStore.removeChangeListener(this.onStoreChange);
  }
  submitDisputeCase = async () => {
    const { userDetails, transactionDetails } = this.props;
    this.setState({ isLoading: true, isContinueClicked: true });
    try {
      const {
        name: { first_name: firstName = '' },
      } = await requestCustomerDetails();
      FraudAndDisputeActionCreator.submitDisputeCase(
        getDisputeApiPayload({ ...userDetails, firstName }, transactionDetails)
      );
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_review_your_dispute,
        config.analytics.analytics_action_button_click
      );
    } catch (_error) {
      InternetBankingActions.navigateToWebTask(WEB_ERROR_TASK);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_error,
        config.analytics.analytics_action_page_loaded
      );
    }
  };
  render() {
    const { content, setPage, userDetails, transactionDetails, logoInitials } =
      this.props;
    const { isLoading } = this.state;
    const contactInfo = userDetails?.phone_numbers?.filter(
      (number) => number.preferred
    );
    const contactDetailsListItems = [
      { key: content.mobileNumberText, value: contactInfo[0]?.phone_number },
      {
        key: content.emailAddress,
        value: userDetails?.email_addresses[0]?.value,
      },
    ];
    const goodsOrServicesDisputeDetailsListItems = [
      {
        key: content.whatDidntYouReceive,
        value: FraudAndDisputeStore.getDisputeJourneyType(),
      },
      {
        key:
          FraudAndDisputeStore.getDisputeJourneyType() === GOODS
            ? content.expectedDeliveryDate
            : content.expectedStartDateTitleText,
        value: moment(
          FraudAndDisputeStore.getDisputeJourneyType() === GOODS
            ? FraudAndDisputeStore.getGoodsExptectedDeliveryDate()
            : FraudAndDisputeStore.getExptectedServiceStartDate()
        ).format(general.dateFormatTimeline),
      },
      {
        key:
          FraudAndDisputeStore.getDisputeJourneyType() === GOODS
            ? content.descriptionOfGoods
            : content.descriptionOfServices,
        value:
          FraudAndDisputeStore.getDisputeJourneyType() === GOODS
            ? FraudAndDisputeStore.getGoodsDescriptionText()
            : FraudAndDisputeStore.getServiceDescriptionText(),
      },
    ];

    const travelDisputeDetailsListItems = [
      {
        key: content.whatDidntYouReceive,
        value: FraudAndDisputeStore.getDisputeJourneyType(),
      },
      {
        key: content.expectedDepartureDate,
        value: moment(
          FraudAndDisputeStore.getExpectedTravelDepartureDate()
        ).format(general.dateFormatTimeline),
      },
      {
        key: content.expectedReturnDate,
        value: moment(
          FraudAndDisputeStore.getExpectedTravelReturnDate()
        ).format(general.dateFormatTimeline),
      },
      {
        key: content.descriptionOfTravel,
        value: FraudAndDisputeStore.getTravelDescriptionText(),
      },
    ];

    const refundDetails = () => {
      const { content } = this.props;
      return FraudAndDisputeStore.getRefundType() === CLAIM_TYPE.PARTIAL_REFUND
        ? `${
            content.partialRefund
          } £${FraudAndDisputeStore.getPartialRefundAmount()}`
        : `${content.fullRefund} £${Math.abs(transactionDetails.rawAmount)}`;
    };

    const contactWithSellerDetailsListItems = [
      {
        key: content.contactDate,
        value: moment(FraudAndDisputeStore.getSellerContactDate()).format(
          general.dateFormatTimeline
        ),
      },
      {
        key: content.descriptionOfContact,
        value: FraudAndDisputeStore.getSellerContactDescriptionText(),
      },
    ];
    const claimAmountDetailsListItems = [
      {
        key: content.howMuchAreYouClaiming,
        value: refundDetails(),
      },
    ];

    return (
      <ApplicationFormShell
        leftSidebar={
          <DisputeProgressComponent
            items={content.disputeProgressStepperItems}
            currentId="5"
          />
        }
      >
        <PageHeading>{content.reviewYourDispute}</PageHeading>
        <FieldLabel>{content.payment}</FieldLabel>
        <PaymentDetailComponent
          data={transactionDetails}
          logoInitials={logoInitials}
          isFromReview={true}
        />
        <FieldLabel>{content.contactDetails}</FieldLabel>
        <GenericDescriptionList items={contactDetailsListItems} />
        <Inline.LeftAligned
          nodes={[
            <NavigationButton.Tertiary
              key="NavigationButton.editContactDetails"
              data-test-id="editContactDetails"
              labelText={content.editContactDetails}
              onClick={() => {
                InternetBankingActions.navigateToWebTask(
                  'WEB-MANAGE-PERSONAL-DETAILS'
                );
              }}
            />,
          ]}
        />
        <FieldLabel>{content.disputeDetails}</FieldLabel>
        <GenericDescriptionList
          items={
            FraudAndDisputeStore.getDisputeJourneyType() === TRAVEL
              ? travelDisputeDetailsListItems
              : goodsOrServicesDisputeDetailsListItems
          }
        />
        <Inline.LeftAligned
          nodes={[
            <NavigationButton.Tertiary
              key="NavigationButton.editDisputeDetails"
              data-test-id="editDisputeDetails"
              labelText={content.editDisputeDetails}
              onClick={() => {
                FraudAndDisputeActionCreator.displayReviewScreen(false);
                setPage(PAGE_WHAT_DIDNT_YOU_RECEIVE);
              }}
            />,
          ]}
        />
        <FieldLabel>{content.contactWithSeller}</FieldLabel>
        <GenericDescriptionList items={contactWithSellerDetailsListItems} />
        <Inline.LeftAligned
          nodes={[
            <NavigationButton.Tertiary
              key="NavigationButton.editContactWithTheSellerDetails"
              data-test-id="editContactWithTheSellerDetails"
              labelText={content.editContactWithSeller}
              onClick={() => {
                FraudAndDisputeActionCreator.displayReviewScreen(false);
                setPage(PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER);
              }}
            />,
          ]}
        />
        <FieldLabel>{content.claimAmount}</FieldLabel>
        <GenericDescriptionList items={claimAmountDetailsListItems} />
        <Inline.LeftAligned
          nodes={[
            <NavigationButton.Tertiary
              key="NavigationButton.editClaimAmountDetails"
              data-test-id="editClaimAmountDetails"
              labelText={content.editClaimAmount}
              onClick={() => {
                FraudAndDisputeActionCreator.displayReviewScreen(false);
                setPage(PAGE_CLAIM_AMOUNT);
              }}
            />,
          ]}
        />
        <div className="dispute-nav-buttons">
          <NavigationButton.Primary
            labelText={content.continueButtonText}
            onClick={() => {
              this.submitDisputeCase();
            }}
          />
          ,
        </div>
        {isLoading && <LoaderComponent type="large" />}
      </ApplicationFormShell>
    );
  }
}

ReviewYourDispute.propTypes = {
  content: PropTypes.object,
  setPage: PropTypes.func,
  userDetails: PropTypes.object,
  transactionDetails: PropTypes.object,
  logoInitials: PropTypes.string,
};
